import {
  ACCORDION_BLOCK,
  BEFORE_AND_AFTER,
  COMPARISON_TABLE,
  FEATURES_BLOCK,
  GALLERY_BLOCK,
  GALLERY_PAGE,
  HOMEPAGE_HERO,
  IFRAME_BLOCK,
  KONTACT_BLOCK,
  MUSTER,
  PAGE_HERO,
  PRODUCTS_BLOCK,
  TEXT_BLOCK,
  TEXT_GALLERY,
  TEXT_IFRAME_BLOCK,
  PROJECT_BLOCK,
  TOPICS_BLOCK,
  VIDEO_BLOCK,
  TEAM_BLOCK,
  FORM_BLOCK,
} from './blocks';
import { META } from './meta';

export const PAGES = `
  query Pages($locale: LocaleInputType, $fallbackLocale: FallbackLocaleInputType) {
    Pages(limit: 300, locale: $locale, fallbackLocale: $fallbackLocale)  {
      docs {
        id
        slug
        parentSlug
        updatedAt
        meta {
          robotsTag
        }
      }
    }
  }
`;

export const PAGE = `
  query Page($slug: String, $draft: Boolean, $locale: LocaleInputType, $parentSlug: String ) {
    Pages(locale: $locale, where: { slug: { equals: $slug }, parentSlug: {equals: $parentSlug}}, limit: 1, draft: $draft) {
      docs {
        id
        title
        slug
        parentSlug
        disableTopPadding
        layout {
          ${ACCORDION_BLOCK}
          ${BEFORE_AND_AFTER}
          ${COMPARISON_TABLE}
          ${FEATURES_BLOCK}
          ${FORM_BLOCK}
          ${GALLERY_BLOCK}
          ${GALLERY_PAGE}
          ${HOMEPAGE_HERO}
          ${IFRAME_BLOCK}
          ${KONTACT_BLOCK}
          ${PAGE_HERO}
          ${PRODUCTS_BLOCK}
          ${MUSTER}
          ${TEXT_BLOCK}
          ${TEAM_BLOCK}
          ${TEXT_GALLERY}
          ${TEXT_IFRAME_BLOCK}
          ${TOPICS_BLOCK}
          ${PROJECT_BLOCK}
          ${VIDEO_BLOCK}
        }
        meta {
          title
          description
          robotsTag
          useCustomTitle
          canonicalUrl
          image {
            url
          }
        }
      }
    }
  }
`;
